import { Divider, Image } from '@pcln/horizon'
import { useRouter } from 'next/router'
import { Box } from 'pcln-design-system'

import useBootstrapData from '@/hooks/useBootstrapData'

import getCobrandContent from './constants'

// Displays when users are navigated to Priceline through referral partners

export default function Cobrand() {
  const { referral: { id = '', sourceId = '' } = {} } = useBootstrapData()
  const { query } = useRouter()
  const refid = sourceId + id
  const promo = getCobrandContent(refid)

  return promo && query?.refid ? (
    <Box color='background.lightest' width={1}>
      <Divider lineSlotBeforeClassName='my-0' />
      <Image alt={promo.alt} src={promo.src} className='mx-auto block py-2' />
    </Box>
  ) : null
}
